//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "PECARN",
  data() {
    return {
      form: {
        gcs: "0",
        skull0: "0",
        skull1: "0",
        ams: "0",

        hematoma: "0",
        loc: "0",
        sevmech: "0",
        notnormal: "0",

        loc2: "0",
        vomiting: "0",
        sevmech2: "0",
        headache: "0",
      },
      hasScore: false,
      disabled: false,
      defaultJson: {
        "Severe Mechanism": "严重的致伤机制",
        sevmechHint:
          "定义为：\n• 机动车撞击致患者被抛出、同行人员死亡、或翻滚\n• 步行或未戴头盔骑自行车时受到机动车撞击\n• 从 0.9 m （3 英尺）或更高的高度跌落\n• 或头部受到高冲击力物体的撞击",
        "CT not recommended": "不推荐行 CT 检查",
        "History of LOC ≥5 sec": "LOC 持续 ≥ 5 秒",
        "Occipital, parietal or temporal scalp hematoma":
          "枕部、顶部、颞部头皮血肿",
        "Observation versus CT": "观察 vs. CT",
        "CT recommended": "推荐行 CT 检查",
        "History of Vomiting": "曾有呕吐",
        gcsHint: "Glasgow 昏迷评分（GCS）小于 15 分",
        locHint: "LOC = 意识丧失",
        "Not acting normally": "行为异常",
        "Abnormal GCS": "异常 GCS",
        "History of LOC": "曾有 LOC",
        "Age < 2 yo": "年龄 < 2 岁",
        "Age ≥ 2 yo": "年龄 ≥ 2 岁",
        amsHint:
          "符合以下任意一项：\n• 焦虑\n• 嗜睡\n• 反复性的问题\n• 语言交流中反应迟钝",
        "Palpable Skull Fracture": "触诊可及的颅骨骨折",
        "Severe Headache": "剧烈头痛",
        "Signs of AMS": "精神状态改变表现",
        sevmechHint2:
          "定义为：\n• 机动车撞击致患者被抛出、同行人员的死亡、或翻滚\n• 步行或未戴头盔骑自行车时受到机动车撞击\n• 从 1.5 m （5 英尺）或更高的高度跌落\n• 或头部受到高冲击力物体的撞击",
        "Signs of Basilar Skull Fracture": "颅底骨折的体征",
      },
      paininmalleolarorfoot: 0,
      footimagingrequired: 0,
      ankleimagingrequired: 0,
      activeType: "hinchey",
      stopnow: 0,
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
    exclusiveChild(type) {
      this.activeType = type;
    },
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        return "0";
      } else {
        self.stopnow =
          form.gcs +
          (self.activeType == "hinchey" ? form.skull0 : form.skull1) +
          form.ams;
        let result =
          self.stopnow == 0
            ? self.activeType == "hinchey"
              ? form.hematoma + form.loc + form.sevmech + form.notnormal
              : form.loc2 + form.vomiting + form.sevmech2 + form.headache
            : 50;
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Pedi/PECARN.vue